export enum AnnualHolidayAccumulationRule {
  Hours35 = "HOURS_35",
  Days14 = "DAYS_14",
}

export const HOLIDAY_ACCUMULATION_RULE_OPTIONS = Object.values(
  AnnualHolidayAccumulationRule,
);
